<template>
	<div class="row mt-3 pt-10">
		<div class="col-md-12">
			<table class="table table-striped table-condensed">
				<thead>
					<tr>
						<th>Faixas Etárias</th>
						<th>Qtd. de Pessoas</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="perfil in $root.arrays.perfil_etario_escolar" :key="perfil.id">
						<td>{{ perfil.value }}</td>
						<td>
							<span v-for="familiar in item.familiares" :key="familiar.id">
								<span v-if="familiar.perfil_etario_escolar == perfil.id"
									><i class="fas fa-user"></i>
								</span>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	props: ["item"],
};
</script>
